import React from 'react';
import {
  InfoContainer,
  InfoIcon,
  InfoText
} from '../../screens/manage-payment/manage-payment.style';
import { INFO_NEW_ICON } from '@Images';

const InfoBanner: React.FC = () => {
  return (
    <InfoContainer>
      <InfoIcon src={INFO_NEW_ICON} alt="info-icon" />
      <InfoText>
        {`To change the card's network brand, remove and re-add it with the correct provider.`}
      </InfoText>
    </InfoContainer>
  );
};

export default InfoBanner;
